<template>
  <div v-if="formattedDeliveryDate" class="flex items-center pb-2">
    <CarrierLogo
      :carrier-key="carrierKey"
      :carrier-name="carrierName"
    ></CarrierLogo>
    <!-- Commented until further notice - CPP-4446 -->
    <!-- <p class="text-base font-normal">
      {{
        `${carrierName} - ${$t(
          'osp.estimated_deliver_date',
        )} ${formattedDeliveryDate}`
      }}
    </p> -->
  </div>
</template>

<script setup lang="ts">
import type { BasketPackageInformation } from '@scayle/storefront-api'
import { CARRIER_LABELS } from '~/constants/order'

const props = defineProps({
  carrierKey: {
    type: String as PropType<string>,
    required: true,
  },
  deliveryDate: {
    type: Object as PropType<BasketPackageInformation['deliveryDate']>,
    required: true,
  },
})

const $currentShop = useCurrentShop()

const carrierName = computed(() =>
  isDeliveryCarrier(props.carrierKey)
    ? CARRIER_LABELS[props.carrierKey]
    : undefined,
)

const formattedDeliveryDate = computed(
  () =>
    `${formatDeliveryDate(
      props.deliveryDate.min,
      $currentShop.value,
    )} - ${formatDeliveryDate(props.deliveryDate.max, $currentShop.value)}`,
)
</script>
